import {bannerActionTypes as types} from '../constants';

function requestBanners() {
  return {type: types.BANNER_LOAD_REQUEST};
}

function requestBannerSuccess(data) {
  return {
    type: types.BANNER_LOAD_SUCCESS,
    banners: data,
  };
}

function requestBannerFailure(data) {
  return {
    type: types.BANNER_LOAD_FAILURE,
    error: data,
  };
}

function requestBannerDismissal(userId, bannerSlug, dateDismissed) {
  return {
    type: types.BANNER_DISMISSAL_POST,
    userId,
    bannerSlug,
    dateDismissed,
  };
}

export {
  requestBanners,
  requestBannerSuccess,
  requestBannerFailure,
  requestBannerDismissal,
};
